import jwtDecode from 'jwt-decode';

export type JWT = {
  name: string;
  email: string;
  userId: string;
  profiles: string;
  roles: string;
  programs: string;
  publicTypes: string;
  expAC: number;
  exp: number;
  iat: number;
};

/**
 * Decode JWT body
 * If token was not specified or is invalid, it returns null
 */
function decode(token = '') {
  if (!token) return null;

  try {
    return jwtDecode<JWT>(token);
  } catch (e) {
    return null;
  }
}

export { decode };
